import { useOutletContext } from 'react-router-dom'

import { Box, NoticeBox } from '@factorialco/deprecated-design-system'
import { PermissionsGetPermissionsDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import { useIsBecome } from 'modules/core/lib/useIsBecome'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { PermissionGroupsLayout } from 'modules/permissions/components/PermissionGroupsLayout'
import { PERMISSION_GROUP_KIND_ADMIN } from 'modules/permissions/lib/constants'
import Footer from 'modules/permissions/pages/settings/Footer'

import { PermissionGroupContainerProps } from '../PermissionGroupContainer'
import List from './List'

const Group = () => {
  const { permissionGroup } = useOutletContext<PermissionGroupContainerProps>()
  const { company } = useCurrentSession()
  const isBecome = useIsBecome()

  const { data, loading } = useQuery(PermissionsGetPermissionsDocument, {
    variables: {
      permissionsGroupId: permissionGroup.attributes.id,
      companyId: company.id.toString(),
    },
  })

  const permissions = (data?.permissions.permissions || []).filter(
    // The permission "delegations" go in a separate tab, so we don't need to render them here.
    (permission) => permission.verb !== 'Permissions::Verbs::ManagePermission'
  )

  const shouldDisablePermissions =
    isBecome ||
    permissionGroup.attributes.kind === PERMISSION_GROUP_KIND_ADMIN ||
    !!permissionGroup.attributes.legacy_admin

  // FIXME: We're rendering each tab of this page as if they were a separate page, each having their
  // own header and tabs. This is not ideal, we should be rendering this page just once with the
  // header, tabs and then let the content of each tab be rendered by an outlet.
  // Bonus points from migrating all that <Card> stuff to a proper <Page> components from Gamma
  // while we're at it.
  return (
    <ResponsivePage.Body loading={loading} error={null} showHeader={false}>
      <PermissionGroupsLayout />
      <Box gap="s12">
        {isBecome && <NoticeBox message={i18n.t('settings.permissions.group.become_warning')} />}
        <List
          disabled={shouldDisablePermissions}
          permissionGroupId={permissionGroup.attributes.id}
          permissions={permissions}
        />
      </Box>

      <Box width="full" padding="s64">
        <Footer />
      </Box>
    </ResponsivePage.Body>
  )
}

export default observer(Group)
